export default __webpack_public_path__ + "static/media/ISO27001_DISS-CO_44 121 222498 englisch.0457334f.pdf";